import React from 'react'
import {IIncomeDocument} from '../IncomeDocumentDetailPage'
import {Col, Row} from 'react-bootstrap'
import {KTCard, KTCardBody} from '../../../../_metronic/helpers'
import {numberFormat} from '../../../utils/Functions'
import {IncomeDocumentTypes} from '../../../constants/Common'
import {Link} from 'react-router-dom'
import {getRevenuePrefixPath} from '../../../utils/Helper'

interface ITabDocumentDepositExpense {
  document: IIncomeDocument
}

const TabDocumentDepositExpense: React.FC<ITabDocumentDepositExpense> = (props) => {
  const {document} = props

  const totalDepositAmount = Number(document.totalAmount)
  const depositDeductionAppliedDocuments = document.incomeDocumentDepositDeductions

  const totalDeducted = depositDeductionAppliedDocuments?.reduce(
    (a, b) => a + Number(b.amount) + Number(b?.vatPrice || 0),
    0
  )
  // console.log({totalDepositAmount})
  // console.log({totalDeducted})
  const currentTotal = totalDepositAmount + totalDeducted - totalDeducted

  return (
    <div>
      <KTCard>
        <KTCardBody className={'py-3 px-4'}>
          <Row className={'fs-6'}>
            <Col xs={12}>
              <h4>{'ข้อมูลการหักเงินมัดจำ'}</h4>
            </Col>
            <Col md={6} className={'border-end'}>
              <div className={'d-flex justify-content-between'}>
                <strong>{'มูลค่าก่อนหักมัดจำ :'}</strong>
                <span>{`${numberFormat(totalDepositAmount + totalDeducted)} บาท`}</span>
              </div>
              <div className={'d-flex justify-content-between'}>
                <strong>{`มูลค่าใบรับเงินมัดจำ จำนวน ${depositDeductionAppliedDocuments.length} รายการ :`}</strong>
                <span>{`${numberFormat(totalDeducted)} บาท`}</span>
              </div>
            </Col>
            <Col md={6}>
              <div className={'d-flex justify-content-between'}>
                <strong>{'มูลค่าหลังหักมัดจำ :'}</strong>
                <div>
                  {/* {currentTotal === 0 ? (
                    <div className={'fs-3 fw-bold text-end'} style={{color: '#43bf76'}}>
                      {' หักมัดจำครบแล้ว'}
                    </div>
                  ) : ( */}
                  <div
                    className={'py-2 px-3 text-end'}
                    style={{minWidth: 150, background: '#f5fcf8', color: '#43bf76'}}
                  >
                    <strong className={'fs-4'}>{numberFormat(currentTotal)}</strong>
                    <span className={'ms-2'}>{'บาท'}</span>
                  </div>
                  {/* )} */}
                </div>
              </div>
            </Col>
          </Row>
        </KTCardBody>
      </KTCard>
      {depositDeductionAppliedDocuments?.map((doc: any, index) => {
        const incomeDocument = doc.deposit
        const pathPrefix = getRevenuePrefixPath(incomeDocument.type)
        return (
          <KTCard className={'mt-3'} key={`deposit-deduction-${index}`}>
            <KTCardBody className={'py-3 px-4'}>
              <Row className={'fs-6'}>
                <Col xs={12}>
                  <h4 style={{color: '#43bf76'}}>{`เอกสารที่นำเงินมัดจำไปหัก ใบที่ ${
                    index + 1
                  }`}</h4>
                </Col>
                <Col md={6} className={'border-end'}>
                  <div className={'d-flex gap-2'}>
                    <strong>{'เลขที่เอกสาร :'}</strong>
                    <Link to={`${pathPrefix}/${incomeDocument.id}/detail`}>
                      {incomeDocument.code}
                    </Link>
                  </div>
                  <div className={'d-flex justify-content-between'}>
                    <span>{'จำนวนยอด :'}</span>
                    <span>{`${numberFormat(
                      Number(doc?.amount || 0) + Number(doc?.vatPrice || 0)
                    )} บาท`}</span>
                  </div>
                </Col>
              </Row>
            </KTCardBody>
          </KTCard>
        )
      })}
    </div>
  )
}

export default TabDocumentDepositExpense
